import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.txtBody2,
  },
  bkgPic: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  modalBody: {
    ...theme.typography.txtBody1,
    fontFamily: 'Inter',
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 14,
    textAlign: "center",
    color: "#5C6477"
  },
  })
);

export default useStyles;